import { Image, Text, View } from '@react-pdf/renderer'
import { useEffect, useRef, useState } from 'react'
import reactImageSize from 'react-image-size'
import { parseFormLabelText } from '../../common/Common'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

export const FormImagePdf = ({
  id,
  langVersion,
  title,
  typeProps,
  padding,
  describeMap,
  objectsFieldsMap,
  ...props
}) => {
  const { imgLink, width, centerImage } = typeProps
  const [calcHeight, setCalcHeight] = useState()
  const [calcWidth, setCalcWidth] = useState()
  const ref = useRef()
  const url = imgLink

  const source = parseFormLabelText({
    text: url,
    langVersion,
    describeMap,
    objectsFieldsMap,
    returnString: true
  })

  useEffect(() => {
    if (width) {
      reactImageSize(source).then(({ width: nativeWidth, height: nativeHeight }) => {
        const aspectRatio = nativeHeight / nativeWidth
        const finalWidth = width || nativeWidth
        setCalcHeight(finalWidth * aspectRatio)
        setCalcWidth(+finalWidth)
      })
    }
  }, [width, source])

  const imgStyle = {}
  if (width) {
    imgStyle.width = +width
  }

  return (
    <View
      typeProps={typeProps}
      ref={ref}
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <View
        style={{
          alignSelf: centerImage ? 'center' : 'auto'
        }}
      >
        <Image
          src={source}
          style={{
            ...imgStyle,
            ...(calcHeight ? { height: calcHeight } : {}),
            ...(calcWidth ? { width: calcWidth } : {}),
            maxWidth: '100%',
            objectFit: 'contain'
          }}
        />
        <Text
          style={{
            fontWeight: 'bold',
            marginTop: 5,
            fontSize: pdfDefaultFontSize
          }}
        >
          {title || ''}
        </Text>
      </View>
    </View>
  )
}
